<template>
	<div class="container__registers">
		<ContentHeader />
		<ContentBody>
			<Card style="background: transparent; background-color: transparent; border: none">
				<div class="not__published__container">
					<div
						v-if="getAboutToRelease.length"
						class="not__published__heading"
					>
						<label class="not__published__title">{{
							`${$t('notPublished')} (${$t('yet')})`
						}}</label>
						<label class="not__published__subtitle">{{ `${$t('helpNotPublished')}` }}</label>
					</div>
					<div class="not__published__items">
						<Tag
							v-for="item in getAboutToRelease"
							:key="item"
							style="font-size: 0.7rem"
							:label="$t(item)"
							class-name="neutral outlined"
						/>
					</div>
					<div class="timeline__published__releases">
						<div
							v-for="release in getReleases"
							:key="release.versao"
							class="release__item"
						>
							<hr
								v-if="getAboutToRelease.length"
								style="margin: 1rem 0; border-top: 0.8px solid #bbb; border-radius: 5px"
							/>
							<label style="font-size: 1.5rem"
								>{{ formatDate(release.timestamp) }} <strong>{{ release.version }}</strong></label
							>

							<div style="display: flex; font-size: 0.6rem; gap: 0.5rem">
								<span
									v-for="product in release.products"
									:key="product.name"
									>{{ `${product.name} ${product.version}` }}</span
								>
							</div>
							<!-- <p>Sprint {{release.sprint}}</p> -->

							<label class="release__description">{{ release.description }}</label>

							<div v-if="release.changes.added">
								<Tag
									style="margin: 1rem 0; font-size: 0.7rem"
									class-name="default outlined"
									:label="$t('added')"
								/>

								<ul>
									<li
										v-for="added in release.changes.added"
										:key="added"
									>
										{{ $t(added) }}
									</li>
								</ul>
							</div>

							<div v-if="release.changes.changed">
								<Tag
									style="margin: 1rem 0; font-size: 0.7rem"
									class-name="warning outlined"
									:label="$t('changed')"
								/>

								<ul>
									<li
										v-for="changed in release.changes.changed"
										:key="changed"
									>
										{{ $t(changed) }}
									</li>
								</ul>
							</div>

							<div v-if="release.changes.deprecated">
								<Tag
									style="margin: 1rem 0; font-size: 0.7rem"
									class-name="neutral outlined"
									:label="$t('deprecated')"
								/>

								<ul>
									<li
										v-for="deprecated in release.changes.deprecated"
										:key="deprecated"
									>
										{{ $t(deprecated) }}
									</li>
								</ul>
							</div>

							<div v-if="release.changes.removed">
								<Tag
									style="margin: 1rem 0; font-size: 0.7rem"
									class-name="danger outlined"
									:label="$t('removed')"
								/>

								<ul>
									<li
										v-for="removed in release.changes.removed"
										:key="removed"
									>
										{{ $t(removed) }}
									</li>
								</ul>
							</div>

							<div v-if="release.changes.security">
								<Tag
									style="margin: 1rem 0; font-size: 0.7rem"
									class-name="primary outlined"
									:label="$t('security')"
								/>

								<ul>
									<li
										v-for="security in release.changes.security"
										:key="security"
									>
										{{ $t(security) }}
									</li>
								</ul>
							</div>

							<div v-if="release.changes.fixed">
								<Tag
									style="margin: 1rem 0; font-size: 0.7rem"
									class-name="info outlined"
									:label="$t('fixed')"
								/>

								<ul>
									<li
										v-for="fixed in release.changes.fixed"
										:key="fixed"
									>
										{{ $t(fixed) }}
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</Card>
		</ContentBody>
	</div>
</template>

<script>
import Card from '../../components/Card/Card'
import ContentBody from '../../components/ContentBody/ContentBody'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import Tag from '../../components/Tag/Tag'

import { mapGetters } from 'vuex'
export default {
	name: 'Changelog',
	components: { Card, ContentBody, ContentHeader, Tag },
	computed: {
		...mapGetters('moduleChangelog', ['getReleases', 'getAboutToRelease']),
	},
	methods: {
		formatDate(timestamp) {
			const date = new Date(timestamp)
			const month =
				date
					.toLocaleDateString('default', {
						month: 'long',
					})
					.charAt(0)
					.toUpperCase() +
				date
					.toLocaleDateString('default', {
						month: 'long',
					})
					.slice(1)
			return `${month} ${date.getDate()}, ${date.getFullYear()}`
		},
	},
}
</script>

<style>
.release__item {
	margin: 1rem 0;
	background: var(--color-background-card-info);
	padding: 2rem;
	border-radius: 10px;
	box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.1);
}

.not__published__title {
	font-size: 1rem;
	font-weight: 700;
	color: rgb(var(--color-primary));
}

/* .not_bublished_subtitle,
.release__description {
  font-size: 0.75rem;
  color: var(--color-gray);
} */

.release__description {
	color: grey;
}

.not__published__container {
	width: 80%;
	margin: 0 auto;
	align-content: center;
	margin-bottom: 5rem;
}

.not__published__heading {
	margin-top: 4rem;
	width: 100%;
	display: flex;
	flex-direction: column;
}

.not__published__items {
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
	margin-top: 1rem;
}
</style>
